<template>
    <GlobalWindow
        :title="title"
        :visible.sync="visible"
        :confirm-working="isWorking"
        @confirm="confirm"
    >
        <el-form :model="form" ref="form" :rules="rules">
            <el-form-item label="门禁组名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入门禁组名称" v-trim/>
            </el-form-item>
            <el-form-item label="适用用户" prop="type">
                <el-radio-group v-model="form.type">
                    <el-radio label="0">劳务访客</el-radio>
                    <el-radio label="1">普通访客</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
    </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaDeviceRoleWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        name: '',
        type: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/deviceRole',
      'field.id': 'id'
    })
  }
}
</script>
